import More from "./more";
import HorizontalScroll from "./horizontal-scroll";

/**
 * used for the SPA fetching effect
 * also has some uniques for that website regarding
 * setting CSS classes for animations per page-type
 */
export default (() => {
  const siteUrl = `${window.location.protocol}//${top.location.host.toString()}`
  const siteMain = document.getElementById("main")
  const historyArr = []
  const transitionClass = "fader"
  const spinnerHtml = '<div class="spinner"></div>'
  const animationClass = "blowover"
  const animationOutClass = "blowout"
  const animationTargetClass = "js-blowover-animation"
  const animationOutTargetClass = "js-blowout-animation"
  const animationTime = 500
  const linkSelector = `a[href^='${siteUrl}'], a[href^='/'], a[href^='./'], a[href^='../'], a[href^='#'], .js-internal-link`
  const skipLinkSelector = "js-skip-fetcher"
  let lastURL

  const init = () => {
    historyArr.push(window.location.href)

    _addInternalLinksListener(document)

    window.addEventListener("popstate", () => {
      historyArr.pop()
      lastURL = historyArr[historyArr.length - 1]

      if (historyArr.length >= 1) {
        _fetch(lastURL)
      } else {
        history.back()
      }
    })

    // add loading spinner once
    siteMain.insertAdjacentHTML("afterend", spinnerHtml)
  }

  const _addInternalLinksListener = (el) => {
    let internalLinks = el.querySelectorAll(linkSelector);

    if (internalLinks.length === 0) {
      return
    }

    internalLinks = Array.from(internalLinks).filter(link => {
      return !link.classList.contains(skipLinkSelector)
    })

    for (const internalLink of internalLinks) {
      internalLink.addEventListener("click", (e) => {
        e.preventDefault()

        const url = internalLink.getAttribute("href")

        // @todo: put animation stuff into external module?
        // reset body class
        document.body.className = ""
        // and set body class
        if (internalLink.classList.contains("js-to-project-link")) {
          internalLink.parentElement.classList.remove(animationOutTargetClass)
          document.body.className = "bg-projects"
        }
        if (internalLink.classList.contains("js-to-overview-link")) {
          document.body.className = "bg-overviews"
        }

        if (internalLink.classList.contains(animationTargetClass)) {
          // prevent blowing out the clicked element itself
          internalLink.classList.add(animationClass)
          const animateOutTarget = document.querySelectorAll(`.${animationOutTargetClass}`)
          animateOutTarget.forEach(el => {
            el.classList.add(animationOutClass)
          })

          _clickFetch(url, true)
          return
        }

        _clickFetch(url, false)
      })
    }
  }

  const _reinitMain = (main) => {
    _addInternalLinksListener(main)

    const projectCloseBtn = document.querySelector(".js-project-close")
    if (projectCloseBtn !== null && "prevUrl" in window.history.state) {
      projectCloseBtn.setAttribute("aria-hidden", "false")
      projectCloseBtn.setAttribute("href", window.history.state.prevUrl)
    }

    More.init()
    HorizontalScroll.init()
    siteMain.classList.remove(transitionClass)
  }

  /**
   * checks if fetch shall start
   *
   * @param {string} url
   * @param {boolean} isWaitingForAnimation
   * @private
   */
  const _clickFetch = (url, isWaitingForAnimation) => {
    if (url === window.location.href) {
      return
    }

    _fetch(url, true, isWaitingForAnimation)
  }

  /**
   * fetch other pages content
   *
   * @param {string} url
   * @param {boolean} addHistory
   * @param {boolean} isWaitingForAnimation
   * @private
   */
  const _fetch = (url, addHistory, isWaitingForAnimation) => {
    if (isWaitingForAnimation) {
      setTimeout(() => {
        siteMain.classList.add(transitionClass)
      }, animationTime)
    } else {
      siteMain.classList.add(transitionClass)
    }


    fetch(url)
      .then((dataWrappedByPromise) => dataWrappedByPromise.text())
      .then((data) => {
        if (addHistory) {
          historyArr.push(url)
        }
        history.pushState({ prevUrl: window.location.href }, null, url)

        // @todo: error when getContent results in catch here! even if not offline issue
        _getContent(data, isWaitingForAnimation)
      })
      .catch((error) => {
        const offlineUrl = `${siteUrl}/404/`
        window.location.replace(offlineUrl)
        console.error("Error:", error)
      })
  }

  /**
   * sets html content from fetched page
   *
   * @param {string} html
   * @param {boolean} isWaitingForAnimation
   * @private
   */
  const _getContent = (html, isWaitingForAnimation) => {
    const parser = new DOMParser()
    const content = parser.parseFromString(html, "text/html")
    const newMain = content.querySelector("#main").innerHTML
    const newTitle = content.querySelector("title").innerHTML


    document.querySelector("title").innerHTML = newTitle

    if (isWaitingForAnimation) {
      setTimeout(() => {
        siteMain.innerHTML = ""
        siteMain.insertAdjacentHTML("afterbegin", newMain)
        _reinitMain(siteMain)
      }, animationTime)
    } else {
      siteMain.innerHTML = ""
      siteMain.insertAdjacentHTML("afterbegin", newMain)
      _reinitMain(siteMain)
    }
  }

  return {
    init
  }
})()
